/*
 * @Author: yusha
 * @Date: 2023-08-21 16:25:00
 * @LastEditors: yusha
 * @LastEditTime: 2023-08-21 16:25:01
 * @Description:基础底图
 */
/** 基础底图 */
export const BASE_IMAGE = 'https://static-s.theckb.com/UI/PC_icon/logo.svg'
